import { render, staticRenderFns } from "./Recom.vue?vue&type=template&id=13596c96"
import script from "./Recom.vue?vue&type=script&lang=js"
export * from "./Recom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports